import { render, staticRenderFns } from "./FilmTypeBubble.vue?vue&type=template&id=49973636&scoped=true&"
import script from "./FilmTypeBubble.vue?vue&type=script&lang=js&"
export * from "./FilmTypeBubble.vue?vue&type=script&lang=js&"
import style0 from "./FilmTypeBubble.vue?vue&type=style&index=0&id=49973636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49973636",
  null
  
)

export default component.exports